import { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, COLLAPSE_KEY } from '@/components/Sidebar/Sidebar';
import { Topbar } from '@/components/Topbar/Topbar';
import { Footer } from '@/components/Footer/Footer';
import { Spinner } from '@/components/ui/Spinner';
import { classNames } from '@/lib/format';

export function AppLayout() {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try { return localStorage.getItem(COLLAPSE_KEY) === 'true'; } catch { return false; }
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem(COLLAPSE_KEY, String(collapsed)); } catch { /* ignore */ }
  }, [collapsed]);

  return (
    <div className={classNames('app-shell', collapsed && 'app-shell--sidebar-collapsed')}>
      <Sidebar
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((c) => !c)}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />
      {mobileOpen ? <div className="app-shell__overlay" onClick={() => setMobileOpen(false)} /> : null}

      <div className="app-main">
        <Topbar onOpenSidebar={() => setMobileOpen(true)} />
        <main className="app-content">
          <Suspense fallback={<div style={{ padding: 48, textAlign: 'center' }}><Spinner /></div>}>
            <Outlet />
          </Suspense>
        </main>
        <Footer />
      </div>
    </div>
  );
}
